// extracted by mini-css-extract-plugin
export default {"imageContainer":"ColorPicker_imageContainer__Wc9BH"};